import { css } from 'styled-components';

const srOnlyMixin = /*#__PURE__*/css(["clip:rect(1px,1px,1px,1px);clip-path:inset(50%);height:1px;width:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;"]);

export { srOnlyMixin as s };
//# sourceMappingURL=srOnly-D3ByQyko.js.map
